import { inject, Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular/lazy';

/** Additional registration uses the existing API's explicit incomplete value. */
export function requiresProfileSetup(user: { is_complete?: number } | null | undefined): boolean {
  return user?.is_complete === 0;
}

@Injectable({ providedIn: 'root' })
export class ProfileSetupService {
  private readonly modalController = inject(ModalController);
  private pending?: Promise<boolean>;

  open(): Promise<boolean> {
    return this.pending ??= this.present().finally(() => { this.pending = undefined; });
  }

  private async present(): Promise<boolean> {
    const { SetupProfilePage } = await import('@app/features/setup/setup-profile/setup-profile.page');
    const modal = await this.modalController.create({
      component: SetupProfilePage,
      componentProps: { isModal: true },
      cssClass: 'purple-bunny-setup-modal',
      backdropDismiss: true,
      presentingElement: document.querySelector('ion-router-outlet') ?? undefined,
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    return data?.completed === true;
  }
}
